"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cellole": {
    "9b861ea9": [{
      "hkey": "86228677",
      "slug": "baia-domizia-baia-felice",
      "name": "Baia Domizia-Baia Felice",
      "primary": true,
      "skipSearch": false
    }],
    "baia-domizia": [{
      "hkey": "86228677",
      "slug": "baia-domizia-baia-felice",
      "name": "Baia Domizia-Baia Felice",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4245d9bd": [{
      "hkey": "86228677",
      "slug": "baia-domizia-baia-felice",
      "name": "Baia Domizia-Baia Felice",
      "primary": true,
      "skipSearch": false
    }],
    "baia-felice": [{
      "hkey": "86228677",
      "slug": "baia-domizia-baia-felice",
      "name": "Baia Domizia-Baia Felice",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cellole"
    }],
    "6a4e283f": [{
      "hkey": "271cd1e0",
      "slug": "borgo-centore",
      "name": "Borgo Centore",
      "primary": true,
      "skipSearch": false
    }],
    "centora": [{
      "hkey": "271cd1e0",
      "slug": "borgo-centore",
      "name": "Borgo Centore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ed97a662": [{
      "hkey": "cd3094db",
      "slug": "cellole",
      "name": "Cellole",
      "primary": true,
      "skipSearch": false
    }],
    "san-marco": [{
      "hkey": "cd3094db",
      "slug": "cellole",
      "name": "Cellole",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;